import { useRef, useEffect } from "react";

const useIsFirstRender = (): boolean => {
  const isFirstRenderRef = useRef(true);

  useEffect(() => {
    isFirstRenderRef.current = false;
  }, []);

  return isFirstRenderRef.current;
};

export { useIsFirstRender };
